export default __webpack_public_path__ + "media/images/backgrounds/bg-4-180719f615b452cff26013b8d0bf48c4.jpg";